import React, { useEffect, useState } from 'react';
import Layout from '../common/Layout';
import Client from '../utils/prismicConfig';
import './CV.css';

const CV_DOC_URL =
  'https://docs.google.com/document/d/1-0r_Vtd16dau7X0n9xHhDQBBktORVq7N4QiM5k5JQIA/preview?usp=sharing';

const getPrismicLinkUrl = (value) => {
  if (!value) return null;
  if (typeof value === 'string') return value;
  if (value.url) return value.url;
  if (value.link_type === 'Web' && value.url) return value.url;
  if (value.link_type === 'Media' && value.url) return value.url;
  return null;
};

const getFieldValue = (data, keys) => {
  for (const key of keys) {
    if (!key) continue;
    const value = data?.[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }

  return null;
};

const isDirectDownloadUrl = (url) => {
  if (!url) return false;

  const normalized = url.toLowerCase();
  return (
    (normalized.includes('.pdf') ||
      normalized.includes('/media/') ||
      normalized.includes('/api/v2/documents/') ||
      normalized.includes('/files/') ||
      normalized.includes('/download')) &&
    !normalized.includes('docs.google.com') &&
    !normalized.includes('/preview') &&
    !normalized.includes('/view?')
  );
};

export default function CV() {
  const [downloadUrl, setDownloadUrl] = useState('');
  const [googleCvUrl, setGoogleCvUrl] = useState(CV_DOC_URL);

  useEffect(() => {
    const fetchCvContent = async () => {
      try {
        const cvDoc = await Client.getSingle('cv').catch(() => null);
        const legacyCvDoc = await Client.getSingle('CV').catch(() => null);
        const doc = cvDoc || legacyCvDoc;

        if (!doc || !doc.data) return;

        const data = doc.data;
        const pdfUrl = getPrismicLinkUrl(
          getFieldValue(data, [
            'cv-pdf_download',
            'cv_pdf_download',
            'pdf_download',
          ]),
        );
        const googleUrl = getPrismicLinkUrl(
          getFieldValue(data, [
            'google_cv_link',
            'google-cv_link',
            'google_cv_url',
          ]),
        );

        if (pdfUrl && isDirectDownloadUrl(pdfUrl)) {
          setDownloadUrl(pdfUrl);
        }

        if (googleUrl) setGoogleCvUrl(googleUrl);
      } catch (error) {
        console.error('Failed to load CV content from Prismic:', error);
      }
    };

    fetchCvContent();
  }, []);

  return (
    <Layout>
      <div className="cv-page-shell">
        {downloadUrl ? (
          <a
            className="cv-download-button"
            href={downloadUrl}
            target="_blank"
            rel="noreferrer"
          >
            Download
            <span>PDF</span>
          </a>
        ) : null}

        <div className="cv-container">
          <div className="cv-embed-wrap">
            <iframe
              className="cv-embed"
              title="Alice Fleerackers CV"
              src={googleCvUrl}
              allow="fullscreen"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
